export default __webpack_public_path__ + "static/techguru-example8-b44a3d5d0ff9e98a527d1080d88c747b.jpg";